<!-- <ng-container *ngIf="!(masterType == 'QuotationDetail')">
    <app-uic-form #uicFormRef [gFormUIC]="imFormUIC" [gFormGroup]="instructionForm" [openForm]="false"
        [isFormModal]="false" [modalHeader]="'Create Instruction'" (onSubmitEvent)="submitForm()"
        (onCloseEvent)="resetForm()" (formReady)="handleFormReady($event)"></app-uic-form>

    <app-uic-color-table [uicListData]="imListUIC" [tableData]="instructionData" [enableActionColumn]="true"
        [enableAutoSerial]="true" [actionColumnLabel]="'Action'" [actionOptions]="[
                            { actionName: 'Edit', actionIcon: 'fa fa-pencil' },
                            { actionName: 'Delete', actionIcon: 'fa fa-trash' }
                            ]" (actionClick)="handleActionClick($event)">
    </app-uic-color-table>
</ng-container> -->


<ng-container >
    <app-rich-text-editor [control]="instructionsForm.controls.remarks"></app-rich-text-editor>
    <div class="d-flex justify-content-end">
        <div>
            <button class="btn btn-sm btn-primary my-2" (click)="onSubmit()">
                Submit
            </button>
        </div>
    </div>
</ng-container>